export const fetchCompanyByICO = async (ico: string) => {
  const response = await fetch(
    `https://ares.gov.cz/ekonomicke-subjekty-v-be/rest/ekonomicke-subjekty/${ico}`,
  );
  return response.json();
};
